/**
 * Labstep
 *
 * @module components/FilterPost/NewIndex/Boolean/Form
 * @desc Filter Metadata form
 */

import { FormReusableGroup } from 'labstep-web/core/Form/Reusable/Group';
import { PostFilter } from 'labstep-web/services/postFilter';
import type { PostFilterComparisonType } from 'labstep-web/services/postFilter/constants';
import { PostFilterComparison } from 'labstep-web/services/postFilter/constants';
import type React from 'react';
import { useCallback, useState } from 'react';
import { fieldBoolean } from './fields';
import type { IFilterPostReportBooleanFormProps } from './types';

export const getPostFilterBoolean = (
  field: string,
  comparison: PostFilterComparisonType,
  path?: string,
) => {
  return new PostFilter([[field, comparison]], path);
};

export const FilterPostReportBooleanForm: React.FC<
  IFilterPostReportBooleanFormProps
> = ({ addPostFilter, onDone, path, field, defaultValues }) => {
  const [fields, setFields] = useState([fieldBoolean]);
  const onSubmit = useCallback(
    (values): void => {
      const { value } = values.bool;
      const postFilter = getPostFilterBoolean(
        field,
        PostFilterComparison.eq,
        path,
      ).getNode([value]);

      addPostFilter(postFilter, true);
      onDone();
    },
    [path, addPostFilter],
  );

  return (
    <FormReusableGroup
      fields={fields}
      onSubmit={onSubmit}
      onDone={onDone}
      defaultValues={defaultValues}
      addAnother={false}
    />
  );
};
